import React, { Fragment } from "react";
import { Route, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import Main from "../pages/Main";
// import NotFound from "../pages/NotFound";

/**
 * AppPresenter
 */
const AppPresenter = () => (
  <Fragment>
    <Helmet>
      <title>GOODBOY PICTURES</title>
    </Helmet>

    <Switch>
      <Route path="/" component={Main} />
    </Switch>
  </Fragment>
);
export default AppPresenter;
